/* eslint-disable react/destructuring-assignment */

import cx from "classnames";
import { FieldProps } from "formik";
import React from "react";

import styles from "../InputField/InputField.module.scss";

export const Select: React.FC<
  React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >
> = (props) => {
  return (
    <select {...props} className={cx(styles.input, props.className)}>
      {props.children}
    </select>
  );
};

interface DropdownFieldBaseProps {
  className?: string;
  selectClassName?: string;
  errorClassName?: string;
  labelClassName?: string;
  label?: string;
  prefix?: string;
  prefixClassName?: string;
  placeholder?: string;
  alignStart?: boolean;
  options?: { value: string; label: string }[];
  children?: React.ReactNode;
}

export type DropdownFieldProps = DropdownFieldBaseProps & FieldProps;

export const DropdownField: React.FC<DropdownFieldProps> = ({
  field,
  label,
  prefix,
  prefixClassName,
  form: { touched, errors },
  className,
  selectClassName,
  labelClassName,
  errorClassName,
  alignStart = false,
  options,
  children,
  ...props
}) => {
  return (
    <div className={cx(className, styles.inputContainer)}>
      <div className={label && styles.fieldWithLabel}>
        {label && (
          <label
            htmlFor={field.name}
            className={cx(
              styles.label,
              labelClassName,
              !alignStart && styles.spaceBetween,
            )}
            id={field.name}
          >
            {label}
          </label>
        )}
        {prefix && <span className={prefixClassName}>{prefix}</span>}
        <div>
          <Select
            {...field}
            {...props}
            className={cx(styles.input, selectClassName)}
            style={{ width: "100%", height: "40px" }}
          >
            {props.placeholder && (
              <option value="" disabled hidden>
                {props.placeholder}
              </option>
            )}
            {options
              ? options.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))
              : children}
          </Select>
          <span className={styles.arrow} />
        </div>
      </div>
      {touched[field.name] && errors[field.name] && (
        <div className={cx(styles.error, errorClassName)}>
          {errors[field.name]?.toString()}
        </div>
      )}
    </div>
  );
};
